import {take, fork, cancel, put} from 'redux-saga/effects';
import {LOCATION_CHANGE, matchPath, parseSearchQueryParams} from '@computerrock/formation-router';
import routePaths from '../../routePaths';
import qualityManagementFeedbackScreenTabs from '../qualityManagementFeedbackScreenTabs';
import * as qualityManagementFeedbackActionTypes from '../qualityManagementFeedbackActionTypes';
import onQMFeedbackFullScreenMapClickSelectCP from './onQMFeedbackFullScreenMapClickSelectCP';
import modalIds from '../../modalIds';

const qmFeedbackFullScreenMapCPWatcher = function* qmFeedbackFullScreenMapCPWatcher() {
    mainFlow: while (true) {
        yield take(qualityManagementFeedbackActionTypes.START_QM_FEEDBACK_FULL_SCREEN_MAP_CP_WATCHER);

        const onQMFeedbackMapClickSelectContractPartnerTask = yield fork(onQMFeedbackFullScreenMapClickSelectCP);

        while (true) {
            const watcherTerminationAction = yield take([
                qualityManagementFeedbackActionTypes.STOP_QM_FEEDBACK_FULL_SCREEN_MAP_CP_WATCHER,
                LOCATION_CHANGE,
            ]);

            if (watcherTerminationAction.type === qualityManagementFeedbackActionTypes.STOP_QM_FEEDBACK_FULL_SCREEN_MAP_CP_WATCHER) { // eslint-disable-line max-len
                yield cancel(onQMFeedbackMapClickSelectContractPartnerTask);
                yield put({
                    type: qualityManagementFeedbackActionTypes.SET_ACTIVE_CONTRACT_PARTNER_ID,
                    payload: {
                        activeContractPartnerId: null,
                    },
                });
                continue mainFlow;
            }

            const {payload} = watcherTerminationAction;
            const {location} = payload;

            const qmFeedbackRouteMatch = matchPath(location.pathname, {
                path: routePaths.QUALITY_MANAGEMENT_FEEDBACK,
                exact: true,
            });
            const {activeTab} = qmFeedbackRouteMatch ? parseSearchQueryParams(location.search) : {};
            if (!qmFeedbackRouteMatch || activeTab !== qualityManagementFeedbackScreenTabs.QM_OVERVIEW
                || !(location?.query?.modal && location.query.modal === modalIds.QM_FEEDBACK_CP_RANKING)
            ) {
                yield cancel(onQMFeedbackMapClickSelectContractPartnerTask);
                yield put({
                    type: qualityManagementFeedbackActionTypes.SET_ACTIVE_CONTRACT_PARTNER_ID,
                    payload: {
                        activeContractPartnerId: null,
                    },
                });
                continue mainFlow;
            }
        }
    }
};

export default qmFeedbackFullScreenMapCPWatcher;
